export { OrganigrammeModule } from './organigramme.module';
export { OrganigrammeComponent } from './organigramme.component';
export { OrganigrammeEntityResolver } from './entity.resolver';